<template>
  <v-dialog
    v-model="dialog"
    :max-width="width"
    :fullscreen="!noFullscreen && $vuetify.breakpoint.xsOnly"
    :persistent="persistent"
    scrollable
  >
    <v-card>
      <template v-if="title">
        <v-card-title class="text-h6 d-flex flex-nowrap align-start">
          <div class="flex-grow-1 text-truncate t-heading-medium">{{ title }}</div>
          <cp-icon-button
            v-if="showCloseButton"
            icon="$close"
            size="small"
            @click="cancel"
            class="flex-grow-0 ml-4"
            color="black"
          ></cp-icon-button>
        </v-card-title>
      </template>

      <template v-if="$slots['body']">
          <slot name="body"></slot>
      </template>
      <v-card-text v-else-if="message" v-html="message" class="pa-4 black--text body-2"></v-card-text>
      <v-card-text v-else class="pa-0">
        <component :is="component"></component>
      </v-card-text>

      <template v-if="!noAction">
        <v-card-actions>
            <v-spacer></v-spacer>

            <template v-if="$slots['actions']">
                <slot name="actions"></slot>
            </template>
            <template v-else>

                <cp-button
                    v-if="btnError && !btnError.hide"
                    :color="btnError.color"
                    @click="cancel"
                >
                    {{ btnError.text }}
                </cp-button>

                <cp-button
                    v-if="btnSuccess && !btnSuccess.hide"
                    :color="btnSuccess.color"
                    @click="confirm"
                >
                    {{ btnSuccess.text }}
                </cp-button>
            </template>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      size: null,
      persistent: false,
      noFullscreen: false,
      title: '',
      message: '',
      component: null,
      noAction: false,
      showCloseButton: true,
      btnError: null,
      btnSuccess: null,
      beforeClose: null,
    }),
    methods: {
      open(config = {}) {
        const {
          size = null,
          persistent = false,
          noFullscreen = false,
          title = '',
          message = '',
          component = null,
          noAction = false,
          showCloseButton = true,
          btnError = {},
          btnSuccess = {},
          beforeClose = null,
        } = config

        if (!message && !component && !this.$slots['body']) throw 'required content'

        this.size = size
        this.persistent = persistent
        this.noFullscreen = noFullscreen
        this.title = title
        this.message = message
        this.component = component
        this.noAction = noAction

        this.btnError = noAction ? null : {
          color: btnError.color || 'secondary',
          click: btnError.click || (() => {}),
          text: btnError.text || 'Cancelar',
          hide: btnError.hide || false,
        }

        this.btnSuccess = noAction ? null : {
          color: btnSuccess.color || 'primary',
          click: btnSuccess.click || (() => {}),
          text: btnSuccess.text || 'Ok',
          hide: btnSuccess.hide || false,
          close: typeof btnSuccess.close != 'undefined' ? btnSuccess.close : true
        }

        this.dialog = true

        this.showCloseButton = showCloseButton

        this.beforeClose = beforeClose
      },
      close() {
        if (this.beforeClose && typeof this.beforeClose === 'function')
          this.beforeClose()

        this.dialog = false
      },
      confirm() {
        this.btnSuccess && this.btnSuccess.click()

        if (this.btnSuccess.close) {
            this.close()
        }
      },
      cancel() {
        this.btnError && this.btnError.click()
        this.close()
      },
    },
    computed: {
      width() {
        switch (this.size) {
          case 'small':
            return '290'
          case 'large':
            return '800'
          default:
            return '500'
        }
      },
    },
  }
</script>

<style scoped lang="scss">
$border: 1px solid var(--v-neutral-2-base);

.v-card {
  background-color: var(--v-white-base);
  border: $border;
  border-radius: 2px;

  .v-card__title {
    background-color: var(--v-neutral-1-base);
    border-bottom: $border;
    height: 48px;
    padding: 14px 16px 0px;

    .v-btn--icon {
      margin-top: -3px;
    }
  }
  .v-card__actions {
    background-color: var(--v-neutral-1-base);
    border-top: $border;
  }
}
</style>
